import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../services/queryClient";
import { configureDesignSystem } from "../theme/designTheme";
import { AuthProvider } from "./Auth";
import { ToastProvider } from "./Toast";
import { CustomStorageProvider } from "./CustomStorage";

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={configureDesignSystem}>
        <CustomStorageProvider>
          <AuthProvider>
            <ToastProvider>
              <CssBaseline />
              {children}
            </ToastProvider>
          </AuthProvider>
        </CustomStorageProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
